export default __webpack_public_path__ + "static/media/automatskavrata9.b8c0794d.jpg";